import { WorkspaceConfigContext, WorkspaceConfigStorage } from "../../core/internal/workspace/config/WorkspaceConfigContext"
import { IStorage } from "../../core/internal/storage/Storage"
import { WORKSPACE_CONFIG_STORAGE_KEY } from "../../config"
import ObjectUtil from "../../core/internal/util/ObjectUtil"
import { Sdk } from "../../core/internal/model/model"
import { WorkspaceConfigDto } from "../../core/internal/workspace/dto"

interface WorkspaceConfigContextDto {
  config: WorkspaceConfigDto
  lastModified: string | null
}

interface VersionedWorkspaceConfigContextDto extends WorkspaceConfigContextDto {
  version: string
}

export class BrowserWorkspaceConfigStorage implements WorkspaceConfigStorage {
  constructor(private readonly sdk: Sdk, private readonly storage: IStorage) {}

  get(): WorkspaceConfigContext | null {
    const json = this.storage.getItem(WORKSPACE_CONFIG_STORAGE_KEY)
    if (ObjectUtil.isNullOrUndefined(json)) return null
    try {
      const record: VersionedWorkspaceConfigContextDto = JSON.parse(json)
      if (this.sdk.version !== record.version) {
        this.clear()
        return null
      }
      return WorkspaceConfigContext.of(record.config, record.lastModified)
    } catch (e) {
      this.clear()
      return null
    }
  }

  set(context: WorkspaceConfigContext): void {
    const record: VersionedWorkspaceConfigContextDto = {
      config: context.dto,
      lastModified: context.modifiedAt,
      version: this.sdk.version
    }
    this.storage.setItem(WORKSPACE_CONFIG_STORAGE_KEY, JSON.stringify(record))
  }

  static clear(storage: IStorage): void {
    storage.removeItem(WORKSPACE_CONFIG_STORAGE_KEY)
  }

  clear(): void {
    BrowserWorkspaceConfigStorage.clear(this.storage)
  }
}
